// Helper para formatar a data como DD/MM/AAAA para a chave e a mensagem de erro
const formatDate = dateString => {
  const date = new Date(dateString);
  // toLocaleDateString para garantir o formato DD/MM/AAAA
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export { formatDate };
